import React from 'react';
import { Box, Typography } from '@lucid/lego';
import styles from '../WorkspaceAccess.module.scss';
import { User } from '../WorkspaceAccess';
import { useStore } from '../../../../store/store';

type listingProps = {
  data: User[];
  userDetail: (user: User) => void;
  selectedUserId?: string;
};

const Listing: React.FC<listingProps> = ({ data, userDetail, selectedUserId }) => {
  const theme = useStore((state) => state.theme);

  return (
    <>
      {data?.map((user) => (
        <Box
          key={user.profileId}
          pb={16}
          pl={24}
          pr={24}
          pt={16}
          onClick={() => userDetail(user)}
          className={styles.cardBox}
          background={selectedUserId === user.profileId ? 'gray-6' : 'white'}
          theme={theme}
        >
          <Typography
            color={selectedUserId === user.profileId ? 'white' : 'black'}
            theme={theme}
            size="medium"
            variant="h4"
          >
            {user.name}
          </Typography>
          <Typography
            size="small"
            variant="body"
            color={selectedUserId === user.profileId ? 'white' : 'gray-5'}
            theme={theme}
          >
            {user.title}
          </Typography>
        </Box>
      ))}
    </>
  );
};

export default Listing;
